/* eslint import/prefer-default-export: 0 */
import { append, compose, path, split } from 'ramda'
import { NestDataObject } from 'react-hook-form'
import { FlightFormStateType } from '../components/Flights/types'

export const getErrorFromKey = compose(path, append('message'), split('.'))

export const getDateFieldBorderColors = (
  errors: NestDataObject<FlightFormStateType>,
  i: number
) => {
  return errors.flights?.[i]?.startDate ? 'red' : undefined
}

export const getDateFieldErrorMessage = (
  errors: NestDataObject<FlightFormStateType>,
  i: number,
  isRoundTripFlight = false
) => {
  // eslint-disable-next-line no-nested-ternary
  return errors.flights?.[i]?.startDate || errors.flights?.[i]?.endDate
    ? isRoundTripFlight
      ? 'Please select a departing and returning date'
      : 'Please select a departing date'
    : undefined
}
